import image4 from '../../../../assets/images/media/media-67.jpg';
import image5 from '../../../../assets/images/media/media-68.jpg';
import image6 from '../../../../assets/images/media/media-69.jpg';
import image7 from '../../../../assets/images/media/media-70.jpg';
import image8 from '../../../../assets/images/media/media-71.jpg';
import image14 from '../../../../assets/images/faces/3.jpg';
import image15 from '../../../../assets/images/faces/11.jpg';
import image16 from '../../../../assets/images/faces/17.jpg';
import image17 from '../../../../assets/images/faces/15.jpg';
import image18 from '../../../../assets/images/faces/13.jpg';
import image19 from '../../../../assets/images/faces/13.jpg';

//Latest Posts
export const Blogdata1 = [
    { id: 1, image: image4, category: 'Health', title: 'Health care and fitness awareness', timeAgo: '22 hrs ago' },
    { id: 2, image: image5, category: 'Beautician', title: 'Beautification courses are available.', timeAgo: '2 hrs ago' },
    { id: 3, image: image6, category: 'Tourism', title: 'Explore tourism by visiting places.', timeAgo: '2 days ago' },
    { id: 4, image: image7, category: 'Literature', title: 'English and Spanish classes in Your way', timeAgo: '1 week ago' },
    { id: 5, image: image8, category: 'Music', title: 'Music in a peaceful way', timeAgo: '1 day ago' }
]

//Blog AUthors
export const Blogdata2 = [
    { id: 1, image: image14, name: 'Samantha Melon', userId: '#1234', timeAgo: '8 hrs ago', badgeColor: 'text-success' },
    { id: 2, image: image15, name: 'Allie Grater', userId: '#1234', timeAgo: '12 hrs ago', badgeColor: 'text-danger' },
    { id: 3, image: image16, name: 'Gabe Lackmen', userId: '#1234', timeAgo: '1 hr ago', badgeColor: 'text-danger' },
    { id: 4, image: image17, name: 'Manuel Labor', userId: '#1234', timeAgo: '3 days ago', badgeColor: 'text-success' },
    { id: 5, image: image18, name: 'Manuel Labor', userId: '#1234', timeAgo: '22 hrs ago', badgeColor: 'text-danger' },
    { id: 6, image: image19, name: 'Manuel Labor', userId: '#1234', timeAgo: '1 day ago', badgeColor: 'text-danger' }
]